package songwritersnotebook.app.screens

import songwritersnotebook.app.screens.components.*

import androidx.compose.animation.AnimatedContent
import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutVertically
import androidx.compose.animation.togetherWith
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.tween
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.LinearEasing
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.TextRange
import androidx.compose.ui.text.TextLayoutResult
import androidx.compose.ui.text.input.TextFieldValue
import androidx.compose.ui.text.input.KeyboardCapitalization
import kotlinx.coroutines.delay
import kotlinx.coroutines.withTimeoutOrNull
import androidx.compose.foundation.gestures.awaitEachGesture
import androidx.compose.foundation.gestures.awaitFirstDown
import androidx.compose.foundation.gestures.waitForUpOrCancellation
import androidx.compose.ui.draw.drawWithContent
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.gestures.detectHorizontalDragGestures
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.rememberScrollState
import songwritersnotebook.app.utils.NetworkUtils
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.automirrored.filled.MenuBook
import androidx.compose.material.icons.automirrored.filled.Send
import androidx.compose.material.icons.automirrored.filled.Undo
import androidx.compose.material.icons.automirrored.filled.Redo
import androidx.compose.material.icons.filled.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.scale
import androidx.compose.ui.zIndex
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.BlendMode
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.unit.DpSize
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.material.icons.filled.CloudDone
import androidx.compose.material.icons.filled.Save
import androidx.compose.material.icons.filled.Piano
import androidx.compose.material.icons.filled.Check
import songwritersnotebook.app.utils.rememberMicPermissionLauncher
import androidx.compose.material.icons.filled.Edit
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material.icons.filled.MusicNote
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.ui.platform.LocalSoftwareKeyboardController
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.geometry.CornerRadius
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import songwritersnotebook.app.billing.SubscriptionTier
import songwritersnotebook.app.billing.ProductInfo
import songwritersnotebook.app.data.*
import songwritersnotebook.app.navigation.AppRoutes
import songwritersnotebook.app.ui.theme.BlueAccent
import songwritersnotebook.app.ui.theme.GoldAccent
import songwritersnotebook.app.ui.theme.SliderThumbGray
import songwritersnotebook.app.ui.theme.SliderTrackGray
import songwritersnotebook.app.ui.theme.ChordVisualTransformation
import songwritersnotebook.app.utils.countSyllables
import songwritersnotebook.app.viewmodels.*
import kotlinx.datetime.*
import org.jetbrains.compose.resources.painterResource
import songwritersnotebookapp.composeapp.generated.resources.Res
import songwritersnotebookapp.composeapp.generated.resources.ic_guitar

import songwritersnotebook.app.ui.theme.SuccessGreen
import songwritersnotebook.app.components.SaveStatusIndicator
import songwritersnotebook.app.adaptiveSheetWidth
import songwritersnotebook.app.components.ChordPanel
import songwritersnotebook.app.components.ChordCreatorSheet
import songwritersnotebook.app.components.HarmonyAiTabContent
import songwritersnotebook.app.components.TabEditorSheet
import songwritersnotebook.app.components.RecordingSheet
import songwritersnotebook.app.components.LineMediaSheet
import songwritersnotebook.app.components.TabDisplay
import songwritersnotebook.app.components.LoadingOverlay
import songwritersnotebook.app.tutorial.TutorialManager
import songwritersnotebook.app.tutorial.TutorialStep
import songwritersnotebook.app.tutorial.tutorialTarget
import androidx.compose.material3.SegmentedButton
import androidx.compose.material3.SegmentedButtonDefaults
import androidx.compose.material3.SingleChoiceSegmentedButtonRow
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.verticalScroll
import androidx.compose.foundation.rememberScrollState
import songwritersnotebook.app.tutorial.TutorialOverlay
import songwritersnotebook.app.LocalPlatformContext

import androidx.compose.ui.input.key.onPreviewKeyEvent
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.input.key.key
import androidx.compose.ui.input.key.type
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.unit.IntOffset

import songwritersnotebook.app.components.VersionHistorySheet

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun EditorScreen(
    song: Song? = null,
    userProfile: UserProfile? = null,
    subscriptionTier: SubscriptionTier = SubscriptionTier.FREE,
    onBack: () -> Unit = {},
    onSave: (Song) -> Unit = {},
    onNavigateToStudio: (Song) -> Unit = {},
    onNavigateToSubscription: () -> Unit = {},
    aiCreditProducts: List<ProductInfo> = emptyList(),
    onPurchaseCreditPack: (ProductInfo) -> Unit = {},
    viewModel: EditorViewModel,
    fontSize: androidx.compose.ui.unit.TextUnit = 16.sp
) {
    println("DEBUG_DIAG: EditorScreen Composing...")
    
    DisposableEffect(Unit) {
        onDispose {
            viewModel.clearPresenceOnExit()
        }
    }
    
    val uiState by viewModel.uiState.collectAsStateWithLifecycle()
    val canUseTabs = subscriptionTier != SubscriptionTier.FREE
    var isChordPanelExpanded by remember { mutableStateOf(false) }
    var showSettingsSheet by remember { mutableStateOf(false) }
    var showDeviceManagementDialog by remember { mutableStateOf(false) }
    val currentUserId = viewModel.currentUserId
    
    var songTitleValue by remember(song?.id) { 
        mutableStateOf(TextFieldValue(text = song?.title ?: "", selection = TextRange(song?.title?.length ?: 0))) 
    }
    var lastLocalTitleEdit by remember { mutableStateOf(0L) }
    
    // Only adopt cloud title updates if we are not actively saving and not actively typing
    LaunchedEffect(song?.title) {
        val now = Clock.System.now().toEpochMilliseconds()
        val isTyping = (now - lastLocalTitleEdit) < 2000L // 2-second guard
        
        if (uiState.saveStatus != SaveStatus.SAVING && !isTyping && songTitleValue.text != (song?.title ?: "")) {
            val oldText = songTitleValue.text
            val newText = song?.title ?: ""
            val oldSelection = songTitleValue.selection

            val newSelection = if (newText.length > oldText.length) {
                val diffLen = newText.length - oldText.length
                val isPrefixMatch = oldText.take(oldSelection.start.coerceAtMost(oldText.length)) == 
                                   newText.take(oldSelection.start.coerceAtMost(oldText.length))
                if (isPrefixMatch) oldSelection else TextRange(oldSelection.start + diffLen)
            } else if (newText.length < oldText.length) {
                val diffLen = oldText.length - newText.length
                val isPrefixMatch = oldText.take(oldSelection.start.coerceAtMost(oldText.length)) == 
                                   newText.take(oldSelection.start.coerceAtMost(oldText.length))
                if (isPrefixMatch) oldSelection else TextRange((oldSelection.start - diffLen).coerceAtLeast(0))
            } else {
                oldSelection
            }

            songTitleValue = songTitleValue.copy(text = newText, selection = newSelection)
        }
    }
    var tempBpm by remember(uiState.song?.bpm) { mutableStateOf(uiState.song?.bpm ?: 120) }
    var fontSize by remember { mutableStateOf(16.sp) } // Could be from settings
    
    val currentStep by TutorialManager.currentStep.collectAsState()
    
    val isPreviewMode = uiState.versionPreview != null
    val snackbarHostState = remember { SnackbarHostState() }

    LaunchedEffect(uiState.shouldExit) {
        if (uiState.shouldExit) {
            songwritersnotebook.app.utils.PlatformToast.show("Access to this song was revoked.")
            onBack()
        }
    }

    LaunchedEffect(userProfile) {
        viewModel.setUserProfile(userProfile)
    }

    LaunchedEffect(uiState.cloudSyncError) {
        uiState.cloudSyncError?.let {
            snackbarHostState.showSnackbar(
                message = "Cloud Sync Error: $it",
                actionLabel = "Retry",
                duration = SnackbarDuration.Long
            )
            // viewModel.clearCloudSyncError() // Should we clear it?
        }
    }


    if (uiState.showUpgradeDialog) {
        AlertDialog(
            onDismissRequest = { viewModel.dismissUpgradeDialog() },
            title = { Text("Premium Feature") },
            text = { Text(uiState.upgradeMessage) },
            confirmButton = {
                Button(
                    onClick = {
                        viewModel.dismissUpgradeDialog()
                        onNavigateToSubscription()
                    }
                ) {
                    Text("Upgrade")
                }
            },
            dismissButton = {
                TextButton(onClick = { viewModel.dismissUpgradeDialog() }) {
                    Text("Cancel")
                }
            }
        )
    }

    if (uiState.showVersionHistoryOwnerInfoDialog) {
        AlertDialog(
            onDismissRequest = { viewModel.dismissVersionHistoryOwnerInfoDialog() },
            title = { Text("Owner Only") },
            text = { Text("Version history can only be managed by the song owner.") },
            confirmButton = {
                Button(onClick = { viewModel.dismissVersionHistoryOwnerInfoDialog() }) {
                    Text("OK")
                }
            }
        )
    }

    if (uiState.showVersionHistorySheet) {
        VersionHistorySheet(
            versions = uiState.versions,
            isLoading = false, // Flow handles this
            onDismiss = { viewModel.toggleVersionHistorySheet() },
            onPreview = { viewModel.previewVersion(it) },
            onRestore = { viewModel.restoreVersion(it) },
            onDelete = { viewModel.deleteVersion(it) },
            onSaveSnapshot = { notes -> viewModel.saveManualVersion(notes) },
            onUpdateNotes = { ver, notes -> viewModel.updateVersionNotes(ver, notes) },
            isStudio = subscriptionTier == SubscriptionTier.STUDIO
        )
    }

    // Tutorial Registration
    LaunchedEffect(Unit) {
        // --- Enter Actions (Forward & Backward) ---
        TutorialManager.registerEnterAction(TutorialStep.EDITOR_INTRO) {
            viewModel.closeWordFinderPopup()
            viewModel.onAiAssistantDismiss()
            viewModel.onChordCreatorDismissed()
            isChordPanelExpanded = false
        }
        TutorialManager.registerEnterAction(TutorialStep.EDITOR_WORD_FINDER_SEARCH) {
            viewModel.openWordFinderPopup()
        }
        TutorialManager.registerEnterAction(TutorialStep.EDITOR_CHORD_LIBRARY_OPEN) {
            viewModel.closeWordFinderPopup()
            isChordPanelExpanded = true
        }
        TutorialManager.registerEnterAction(TutorialStep.EDITOR_CHORD_LIBRARY_PROGRESSION_TAB) {
            viewModel.closeWordFinderPopup()
            isChordPanelExpanded = true
        }
        TutorialManager.registerEnterAction(TutorialStep.EDITOR_PROGRESSION_BUILDER) {
            viewModel.closeWordFinderPopup()
            isChordPanelExpanded = true
        }
        TutorialManager.registerEnterAction(TutorialStep.EDITOR_OPEN_CREATOR_EXPLAIN) {
            viewModel.closeWordFinderPopup()
            isChordPanelExpanded = true
        }
        TutorialManager.registerEnterAction(TutorialStep.EDITOR_CREATE_CHORD_VOICING) {
            viewModel.onEditChordClicked()
        }
        TutorialManager.registerEnterAction(TutorialStep.EDITOR_CREATE_CHORD_SAVE) {
            viewModel.onAiAssistantDismiss()
        }
        TutorialManager.registerEnterAction(TutorialStep.EDITOR_CONTEXT_MENU_OPEN) {
            viewModel.onAiAssistantDismiss()
            viewModel.onChordCreatorDismissed()
            isChordPanelExpanded = false
            viewModel.closeWordFinderPopup()
        }
        TutorialManager.registerEnterAction(TutorialStep.EDITOR_CONTEXT_MENU_MOVE) {
            val currentState = viewModel.uiState.value
            if (currentState.selectedItem == null) {
                viewModel.selectItem(0, 0)
            }
        }
        TutorialManager.registerEnterAction(TutorialStep.EDITOR_SETTINGS_OPEN) {
            viewModel.cancelSelection()
        }

        // --- Actions (Triggered on "Next" or target click) ---
        TutorialManager.registerAction(TutorialStep.EDITOR_ADD_SECTION) {
            viewModel.closeWordFinderPopup()
        }
        TutorialManager.registerAction(TutorialStep.EDITOR_WORD_FINDER_OPEN) {
            viewModel.openWordFinderPopup()
        }
        TutorialManager.registerAction(TutorialStep.EDITOR_WORD_FINDER_SEARCH) {
            viewModel.closeWordFinderPopup()
        }
        TutorialManager.registerAction(TutorialStep.EDITOR_AI_OPEN) {
            viewModel.onAiAssistantClicked()
        }
        TutorialManager.registerAction(TutorialStep.EDITOR_AI_HARMONY) {
            viewModel.onAiAssistantDismiss()
        }
        TutorialManager.registerAction(TutorialStep.EDITOR_SETTINGS_OPEN) {
            showSettingsSheet = true
        }
        TutorialManager.registerAction(TutorialStep.EDITOR_STUDIO_OPEN) {
            val currentSong = viewModel.uiState.value.song
            if (currentSong != null) onNavigateToStudio(currentSong)
        }
        TutorialManager.registerAction(TutorialStep.EDITOR_CHORD_LIBRARY_OPEN) {
            isChordPanelExpanded = true
            viewModel.onChordCreatorDismissed()
        }
        TutorialManager.registerAction(TutorialStep.EDITOR_CHORD_LIBRARY_SELECT) {
            viewModel.setInstrument("guitar")
            viewModel.selectChordForPlacement("Dm")
        }
        TutorialManager.registerAction(TutorialStep.EDITOR_CHORD_LIBRARY_PROGRESSION_TAB) {
            // Nothing to trigger here, moving to next step
        }
        TutorialManager.registerAction(TutorialStep.EDITOR_PROGRESSION_BUILDER) {
            // Do not open progression builder, just point to it
        }
        TutorialManager.registerAction(TutorialStep.EDITOR_OPEN_CREATOR_EXPLAIN) {
            viewModel.onEditChordClicked()
        }
        TutorialManager.registerAction(TutorialStep.EDITOR_CREATE_CHORD_SAVE) {
            viewModel.onChordCreatorDismissed()
        }
        TutorialManager.registerAction(TutorialStep.EDITOR_CONTEXT_MENU_OPEN) {
            val currentState = viewModel.uiState.value
            if (currentState.selectedItem == null) {
                viewModel.selectItem(0, 0)
            }
        }
    }
    
    if (uiState.showChordCreatorDialog) {
        ChordCreatorSheet(
            initialChordName = uiState.chordToEdit,
            chordCreatorUiState = viewModel.getChordCreatorUiState(),
            onDismiss = { viewModel.onChordCreatorDismissed() },
            onSave = { viewModel.saveNewChord(it) },
            onPlayCurrentChord = { viewModel.playCurrentChordInCreator() },
            onShuffleChord = { viewModel.shuffleChordSelection() },
            onPresetSelected = { root, quality -> viewModel.onPresetChordSelected(root, quality) },
            onSelectQualityCategory = { viewModel.selectQualityCategory(it) },
            onPlayPreset = { root, quality -> viewModel.playChordPreset(root, quality) },
            fretWindowStart = uiState.fretWindowStart,
            onFretWindowChange = { viewModel.updateFretWindowStart(it) },
            onOctaveChange = { viewModel.setKeyboardOctave(it) },
            onClearManualKeys = { viewModel.clearManualKeys() },
            onToggleManualKey = { viewModel.toggleManualKey(it) },
            onTabChange = { viewModel.onTabChange(it) },
            onTuningChange = { index, step -> viewModel.onTuningChange(index, step) },
            onCapoChange = { viewModel.onCapoChange(it) },
            onResetTuning = { viewModel.resetTuningToStandard() },
            onCustomToggle = { viewModel.onCustomToggle() },
            onInit = { viewModel.initChordCreator(it) },
            isFavorited = uiState.isFavorited,
            onToggleFavorite = { viewModel.toggleFavoriteChord(it) },
            isLeftHanded = uiState.editorSettings.isLeftHanded
        )
    }

    if (uiState.showProgressionBuilderDialog) {
        val editingProgression = uiState.progressionToEditId?.let { id -> 
            uiState.song?.progressions?.find { it.id == id } 
                ?: uiState.favoriteProgressions.find { it.progression.id == id }?.progression
        }
        songwritersnotebook.app.components.ProgressionBuilderSheet(
            initialProgression = editingProgression,
            availableChords = uiState.song?.chordDefinitions ?: emptyMap(),
            onDismiss = { viewModel.onProgressionBuilderDismissed() },
            onSave = { prog -> viewModel.saveProgression(prog) },
            onPlayChord = { chordName, instrument -> viewModel.playChordByName(chordName, instrument) },
            onEditChord = { chordName -> 
                viewModel.initChordCreator(chordName)
            },
            onCreateChord = { viewModel.onAddChordClicked() },
            selectedInstrument = uiState.selectedInstrument,
            onInstrumentChange = { viewModel.setInstrument(it) }
        )
    }

    if (uiState.showTabEditorSheet && uiState.editingTab != null) {
        val tabId = uiState.editingTab!!.id
        val targetId = uiState.editingTabTargetId ?: ""
        var targetText = ""
        uiState.song?.sections?.forEach { section ->
            if (section.id == targetId) {
                targetText = section.title + " " + section.lines.joinToString(" ") { it.text }
            }
            section.lines.forEach { line ->
                if (line.id == targetId) targetText = line.text
            }
        }
        val targetChords = Regex("\\[([^\\[\\]]+)\\]").findAll(targetText).map { it.groupValues[1] }.toList()
        val filteredAvailableChords = uiState.song?.chordDefinitions?.values?.filter { it.name in targetChords } ?: emptyList()
        
        val allRecordings = uiState.song?.recordings?.values?.flatten()?.distinctBy { it.id } ?: emptyList()
        val tabRecordings = allRecordings.filter { it.id in uiState.editingTab!!.recordingIds }
        // Use the ID from the tab to find the recording, ensuring we get the instance with the path (from the line list)
        
        val lineRecordings = uiState.song?.recordings?.get(targetId) ?: emptyList()
        
        TabEditorSheet(
            initialTab = uiState.editingTab!!,
            availableChords = filteredAvailableChords,
            onDismiss = { viewModel.dismissTabEditor() },
            onSave = { viewModel.saveTab(it) },
            canUseTabs = canUseTabs,
            onUpgrade = onNavigateToSubscription,
            isLeftHanded = uiState.editorSettings.isLeftHanded,
            recordings = tabRecordings,
            lineRecordings = lineRecordings,
            playingRecordingId = uiState.playingRecordingId,
            onRecordNew = { currentTab ->
                viewModel.saveTab(currentTab, dismiss = false)
                viewModel.onStartRecordingFor(tabId, associatedTabId = tabId, parentTargetId = targetId)
            },
            onPlayRecording = { viewModel.playRecording(it) },
            onSelectExisting = { rec, currentTab ->
                viewModel.saveTab(currentTab, dismiss = false)
                viewModel.linkRecordingToTab(tabId, rec)
            },
            onUnlink = { currentTab ->
                viewModel.saveTab(currentTab, dismiss = false)
                viewModel.unlinkRecordingFromTab(tabId)
            },
            onTabChange = { viewModel.saveTab(it, dismiss = false) },
            songId = uiState.song?.id ?: "",
            targetId = targetId,
            tabId = tabId
        )    }

    if (uiState.showRecordingSheet && uiState.recordingTarget != null) {
        RecordingSheet(
            target = uiState.recordingTarget!!,
            lineText = uiState.recordingTarget!!.lineText,
            audioHandler = viewModel.getAudioHandler(),
            outputFilePath = uiState.recordingTarget!!.outputFile,
            initialAudioUri = null, // Logic for existing recording could go here if editing
            onDismiss = { viewModel.onDismissRecordingSheet() },
            onSave = { path, name -> viewModel.saveRecording(path, name) },
            onDelete = { viewModel.onDismissRecordingSheet() }, // Temp file cleanup not exposed
            editorViewModel = viewModel
        )
    }

    if (uiState.showLineMediaSheet && uiState.editingTabTargetId != null) {
        val targetId = uiState.editingTabTargetId!!
        val recordings = uiState.song?.recordings?.get(targetId) ?: emptyList()
        val tabs = uiState.song?.sections?.flatMap { it.lines }?.find { it.id == targetId }?.tabs 
            ?: uiState.song?.sections?.find { it.id == targetId }?.tabs 
            ?: emptyList()
        
        LineMediaSheet(
            recordings = recordings,
            tabs = tabs,
            activeRecordingId = uiState.playingRecordingId,
            onDismiss = { viewModel.closeLineMediaSheet() },
            onPlayRecording = { rec -> viewModel.playRecording(rec) },
            onDeleteRecording = { rec -> viewModel.deleteRecording(targetId, rec) },
            onRecordNew = { viewModel.onStartRecordingFor(targetId) },
            onRenameRecording = { rec, name -> viewModel.renameRecording(rec, name) },
            onReRecord = { rec -> viewModel.onStartRecordingFor(targetId, rec.id) },
            onEditTab = { tab -> viewModel.openTabEditor(targetId, tab) },
            onDeleteTab = { tab -> viewModel.deleteTab(tab) },
            onNewTab = { viewModel.openTabEditor(targetId) },
            canUseTabs = canUseTabs,
            onUpgrade = onNavigateToSubscription,
            initialTabIndex = uiState.initialMediaTabIndex,
            uploadStatus = uiState.uploadStatus,
            onRetryUpload = { viewModel.retryUpload(it) },
            onMoveRecording = { viewModel.openMoveRecordingDialog(it) },
            saveStatus = uiState.saveStatus,
            onSaveRequested = { viewModel.saveSong() }
        )
    }

    if (uiState.showAiAssistantSheet) {
        // Handled below by AiAssistantPanel
    }
    
    if (uiState.showMoveRecordingDialog && uiState.song != null) {
        songwritersnotebook.app.components.MoveRecordingSheet(
            song = uiState.song!!,
            onDismiss = { viewModel.dismissMoveRecordingDialog() },
            onTargetSelected = { targetId -> viewModel.moveRecording(targetId) }
        )
    }

    if (uiState.showAiLimitDialog) {
        val context = LocalPlatformContext.current
        AiLimitDialog(
            userProfile = userProfile,
            onDismiss = { viewModel.onAiLimitDialogDismiss() },
            onUpgrade = onNavigateToSubscription,
            onWatchAd = { 
                 if (context != null) {
                    viewModel.requestRewardedAiUses(context)
                 } else {
                     println("Error: LocalPlatformContext is null")
                 }
            },
            aiCreditProducts = aiCreditProducts,
            onPurchaseClick = onPurchaseCreditPack
        )
    }

    Box(modifier = Modifier.fillMaxSize()) {
        Scaffold(
            contentWindowInsets = WindowInsets.safeDrawing,
            snackbarHost = { SnackbarHost(snackbarHostState) },
            topBar = {
                if (isPreviewMode) {
                    // RESTORE PREVIEW BANNER
                    Surface(
                        color = MaterialTheme.colorScheme.primaryContainer,
                        modifier = Modifier.fillMaxWidth().statusBarsPadding()
                    ) {
                        Row(
                            modifier = Modifier.padding(horizontal = 16.dp, vertical = 8.dp),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Column(modifier = Modifier.weight(1f)) {
                                Text("Previewing Version", style = MaterialTheme.typography.labelLarge, fontWeight = FontWeight.Bold)
                                Text("This is a read-only snapshot.", style = MaterialTheme.typography.bodySmall)
                            }
                            TextButton(onClick = { viewModel.exitPreview() }) {
                                Text("Cancel")
                            }
                            Button(onClick = { viewModel.commitRestore() }) {
                                Text("Restore This")
                            }
                        }
                    }
                } else {
                    TopAppBar(
                        title = {
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                BasicTextField(
                                    value = songTitleValue,
                                    onValueChange = {
                                        songTitleValue = it
                                        viewModel.updateSongTitle(it.text)
                                    },
                                    textStyle = TextStyle(
                                        color = MaterialTheme.colorScheme.onBackground,
                                        fontSize = MaterialTheme.typography.titleLarge.fontSize,
                                        fontWeight = FontWeight.Bold
                                    ),
                                    singleLine = true,
                                    modifier = Modifier.weight(1f, fill = false),
                                    cursorBrush = SolidColor(MaterialTheme.colorScheme.onSurface),
                                    keyboardOptions = KeyboardOptions(capitalization = KeyboardCapitalization.Sentences)
                                )
                                SaveStatusIndicator(
                                    saveStatus = uiState.saveStatus,
                                    isCloudSyncEnabled = uiState.isShared || subscriptionTier == SubscriptionTier.STUDIO || (uiState.song?.collaborators?.isNotEmpty() == true) || (uiState.song?.viewers?.isNotEmpty() == true) || (uiState.song?.collaboratorEmails?.isNotEmpty() == true),
                                    onClick = { viewModel.saveSong() },
                                    showText = false // Icon only next to title
                                )
                            }
                        },
                        navigationIcon = {
                            IconButton(onClick = {
                                viewModel.saveSong()
                                viewModel.clearPresenceOnExit()
                                onBack()
                            }) {
                                Icon(Icons.AutoMirrored.Filled.ArrowBack, contentDescription = "Go back")
                            }
                        },
                        actions = {
                            val networkUtils = remember { songwritersnotebook.app.utils.NetworkUtils() }
                            var isOnline by remember { mutableStateOf(networkUtils.isNetworkAvailable()) }

                            LaunchedEffect(Unit) {
                                while(true) {
                                    isOnline = networkUtils.isNetworkAvailable()
                                    kotlinx.coroutines.delay(3000)
                                }
                            }
                            LaunchedEffect(uiState.saveStatus) {
                                isOnline = networkUtils.isNetworkAvailable()
                            }

                            TextButton(
                                onClick = { 
                                    if (currentStep == TutorialStep.EDITOR_STUDIO_OPEN) {
                                        TutorialManager.nextStep()
                                    }
                                    viewModel.saveSong()
                                    viewModel.clearPresenceOnExit()
                                    uiState.song?.let { onNavigateToStudio(it) }
                                },
                                modifier = Modifier.tutorialTarget(TutorialStep.EDITOR_STUDIO_OPEN)
                            ) {
                                Text("Studio")
                            }

                            val recoveredRecordings = uiState.song?.recordings?.get("RECOVERED")
                            if (!recoveredRecordings.isNullOrEmpty()) {
                                IconButton(onClick = { viewModel.openLineMediaSheet("RECOVERED") }) {
                                    Icon(Icons.Default.FolderOpen, "Recovered Files", tint = GoldAccent)
                                }
                            }

                            IconButton(
                                onClick = { 
                                    if (currentStep == TutorialStep.EDITOR_SETTINGS_OPEN) {
                                        TutorialManager.nextStep()
                                    }
                                    showSettingsSheet = true 
                                },
                                modifier = Modifier.tutorialTarget(TutorialStep.EDITOR_SETTINGS_OPEN)
                            ) {
                                Icon(Icons.Default.Settings, contentDescription = "Editor Settings")
                            }
                        },
                        colors = TopAppBarDefaults.topAppBarColors(
                            containerColor = MaterialTheme.colorScheme.background
                        )
                    )
                }
            },
            bottomBar = {
                if (!isPreviewMode) {
                    Column(modifier = Modifier.fillMaxWidth()) {
                        AnimatedVisibility(
                            visible = isChordPanelExpanded,
                            enter = slideInVertically(initialOffsetY = { it }),
                            exit = slideOutVertically(targetOffsetY = { it })
                        ) {
                            val currentSong = uiState.song ?: Song.createEmpty()
                            val chordNames = uiState.orderedChordNames.ifEmpty { currentSong.chordDefinitions.keys.sorted() }
                            val favoriteChords by viewModel.favoriteChords.collectAsStateWithLifecycle()

                            println("DEBUG_UI: EditorScreen Rendering ChordPanel. Chords: ${chordNames.size}, StrumOffset: ${uiState.strumOffset}")

                            ChordPanel(
                                orderedChordNames = chordNames,
                                chordLibrary = currentSong.chordDefinitions,
                                favoriteChords = favoriteChords,
                                selectedChord = uiState.selectedChordToPlace,
                                onChordClick = { chord ->
                                    if (uiState.selectedChordToPlace != chord) {
                                        viewModel.playChordByName(chord)
                                    }
                                    viewModel.selectChordForPlacement(chord) 
                                },
                                onAddChordClick = { viewModel.onAddChordClicked() },
                                onEditChord = { viewModel.onEditChordClicked() },
                                chordsInUse = uiState.chordsInUse,
                                onDeleteChord = { chord -> viewModel.onDeleteChordClicked(chord) },
                                selectedInstrument = uiState.selectedInstrument,
                                onInstrumentChange = { instrument -> viewModel.setInstrument(instrument) },
                                strumSpeed = uiState.strumOffset,
                                onStrumSpeedChange = { offset -> viewModel.onStrumOffsetChange(offset) },
                                selectedFavorite = uiState.selectedFavoriteChord,
                                onSelectFavorite = { fav -> viewModel.selectFavorite(fav) },
                                onAddFavoriteToSong = { fav -> viewModel.addFavoriteToSong(fav) },
                                onRemoveFavorite = { fav -> viewModel.removeFavorite(fav) },
                                onEditFavorite = { fav -> viewModel.onEditFavoriteClicked(fav) },
                                onPlayFavorite = { fav -> viewModel.playFavoriteChord(fav) },
                                onAddNewFavorite = { viewModel.initChordCreator(null) },
                                favoriteProgressions = uiState.favoriteProgressions,
                                selectedFavoriteProgression = uiState.selectedFavoriteProgression,
                                onSelectFavoriteProgression = { favProg -> viewModel.selectFavoriteProgression(favProg) },
                                onAddFavoriteProgressionToSong = { favProg -> viewModel.addFavoriteProgressionToSong(favProg) },
                                onEditFavoriteProgression = { favProg -> viewModel.onEditProgressionClicked(favProg.progression.id) },
                                onRemoveFavoriteProgression = { favProg -> viewModel.removeFavoriteProgression(favProg) },
                                onPlayFavoriteProgression = { favProg -> viewModel.playFavoriteProgression(favProg) },
                                progressions = currentSong.progressions,
                                activeProgressionId = uiState.activeProgressionId,
                                activeProgressionIndex = uiState.activeProgressionIndex,
                                onProgressionClick = { id -> 
                                    if (uiState.activeProgressionId == id) {
                                        viewModel.setActiveProgression(null)
                                    } else {
                                        viewModel.setActiveProgression(id)
                                    }
                                },
                                onAddProgressionClick = { viewModel.onAddProgressionClicked() },
                                onEditProgressionClick = { id -> viewModel.onEditProgressionClicked(id) },
                                onDeleteProgressionClick = { id -> viewModel.onDeleteProgressionClicked(id) },
                                onToggleFavoriteProgression = { prog -> viewModel.toggleFavoriteProgression(prog) }
                            )
                        }

                        AnimatedVisibility(
                            visible = uiState.selectedItem?.lineIndex != null && uiState.selectedLineChords.isNotEmpty(),
                            enter = slideInVertically(initialOffsetY = { it }) + fadeIn(),
                            exit = slideOutVertically(targetOffsetY = { it }) + fadeOut()
                        ) {
                            ChordManagementBar(
                                chords = uiState.selectedLineChords,
                                activeChord = uiState.activeChord,
                                validInsertionPoints = uiState.validInsertionPoints,
                                onChordClick = { chordInLine ->
                                    viewModel.playChordByName(chordInLine.name)
                                    viewModel.selectActiveChord(chordInLine)
                                },
                                onSliderChange = { newPosition -> viewModel.updateActiveChordPosition(newPosition) },
                                onSliderRelease = { viewModel.flushActiveChordPosition() },
                                onDeleteActiveChord = { viewModel.deleteActiveChord() }
                            )
                        }

                        AnimatedContent(
                            targetState = uiState.selectedItem != null,
                            transitionSpec = {
                                (slideInVertically { height -> height } + fadeIn())
                                    .togetherWith(slideOutVertically { height -> height } + fadeOut())
                            }
                        ) { isItemSelected ->
                            if (isItemSelected) {
                                ActionMenuBottomBar(
                                    onMoveUp = { viewModel.moveSelectedItemUp() },
                                    onMoveDown = { viewModel.moveSelectedItemDown() },
                                    onDelete = { viewModel.deleteSelectedItem() },
                                    onCancel = { viewModel.cancelSelection() },
                                    onAdd = { viewModel.openLineMediaSheet(uiState.selectedItem!!.id) },
                                    onDuplicate = { viewModel.duplicateSelectedItem() }
                                )
                            } else {
                                EditorBottomBar(
                                    isChordPanelExpanded = isChordPanelExpanded,
                                    onShowChords = { isChordPanelExpanded = !isChordPanelExpanded },
                                    onAddSection = { viewModel.addSection() },
                                    editorViewModel = viewModel,
                                    isViewer = uiState.isViewer || isPreviewMode
                                )
                            }
                        }
                    }
                }
            }
        ) { paddingValues ->
            Box(modifier = Modifier.fillMaxSize()) {
                if (showSettingsSheet) {
                    ModalBottomSheet(
                        onDismissRequest = { 
                            showSettingsSheet = false
                        },
                        sheetState = rememberModalBottomSheetState(),
                        dragHandle = null
                    ) {
                        EditorSettingsSheetContent(
                            settings = uiState.editorSettings,
                            viewModel = viewModel,
                            tempBpm = tempBpm,
                            onTempBpmChange = {
                                tempBpm = it
                                viewModel.onBpmChange(it.toString())
                            },
                            onTempBpmChangeFinished = {
                                viewModel.onBpmChangeRelease(tempBpm.toString())
                            },
                            onShowVersionHistory = {
                                showSettingsSheet = false
                                viewModel.onVersionHistoryClicked()
                            },
                            onDoneEditing = {
                                showSettingsSheet = false
                            }
                        )
                    }
                }

                if (uiState.chordToDelete != null) {
                    AlertDialog(
                        onDismissRequest = { viewModel.cancelChordDeletion() },
                        title = { Text("Delete Chord?") },
                        text = { Text("Delete '${uiState.chordToDelete}' from song and library?") },
                        confirmButton = { Button(onClick = { viewModel.confirmChordDeletion() }) { Text("Delete") } },
                        dismissButton = { TextButton(onClick = { viewModel.cancelChordDeletion() }) { Text("Cancel") } }
                    )
                }

                uiState.itemToDelete?.let { item ->
                    if (item.isMerge) {
                        AlertDialog(
                            onDismissRequest = { viewModel.cancelDeletion() },
                            title = { Text("Merge Line?") },
                            text = { 
                                Text("This line contains tabs or recordings. Do you want to merge these items into the line above, or delete them?") 
                            },
                            confirmButton = { 
                                Button(onClick = { viewModel.confirmDeletionWithMerge() }) { 
                                    Text("Merge Everything") 
                                } 
                            },
                            dismissButton = {
                                Row {
                                    TextButton(onClick = { viewModel.confirmDeletion() }) { 
                                        Text("Delete Media") 
                                    }
                                    Spacer(modifier = Modifier.width(8.dp))
                                    TextButton(onClick = { viewModel.cancelDeletion() }) { 
                                        Text("Cancel") 
                                    }
                                }
                            }
                        )
                    } else {
                        AlertDialog(
                            onDismissRequest = { viewModel.cancelDeletion() },
                            title = { Text("Delete Item?") },
                            text = { Text("Are you sure you want to delete this item?") },
                            confirmButton = { Button(onClick = { viewModel.confirmDeletion() }) { Text("Delete") } },
                            dismissButton = { TextButton(onClick = { viewModel.cancelDeletion() }) { Text("Cancel") } }
                        )
                    }
                }



                if (showDeviceManagementDialog) {
                    val sessions = uiState.userProfile?.activeSessions?.values?.toList() ?: emptyList()
                    val currentDeviceId = viewModel.deviceId

                    AlertDialog(
                        onDismissRequest = { showDeviceManagementDialog = false },
                        title = { Text("Active Devices") },
                        text = {
                            Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
                                Text("You can have up to 3 active devices on your account.", style = MaterialTheme.typography.bodySmall)

                                sessions.forEach { session ->
                                    val isCurrent = session.deviceId == currentDeviceId
                                    Card(
                                        modifier = Modifier.fillMaxWidth(),
                                        colors = CardDefaults.cardColors(
                                            containerColor = if (isCurrent) MaterialTheme.colorScheme.primaryContainer else MaterialTheme.colorScheme.surfaceVariant
                                        )
                                    ) {
                                        Row(
                                            modifier = Modifier.padding(12.dp),
                                            verticalAlignment = Alignment.CenterVertically,
                                            horizontalArrangement = Arrangement.SpaceBetween
                                        ) {
                                            Column(modifier = Modifier.weight(1f)) {
                                                val lastActiveDate = if (session.lastActive > 0) {
                                                    kotlinx.datetime.Instant.fromEpochMilliseconds(session.lastActive.toLong())
                                                        .toLocalDateTime(kotlinx.datetime.TimeZone.currentSystemDefault())
                                                        .date.toString()
                                                } else "Unknown"

                                                Text(
                                                    text = if (isCurrent) "${session.deviceName} (Current)" else session.deviceName,
                                                    style = MaterialTheme.typography.bodyLarge,
                                                    fontWeight = if (isCurrent) FontWeight.Bold else FontWeight.Normal
                                                )
                                                Text(
                                                    text = "${session.platform} • Active $lastActiveDate",
                                                    style = MaterialTheme.typography.bodySmall,
                                                    color = MaterialTheme.colorScheme.onSurfaceVariant
                                                )
                                            }
                                            if (!isCurrent) {
                                                IconButton(onClick = { viewModel.removeSession(session.deviceId) }) {
                                                    Icon(Icons.Default.Delete, contentDescription = "Remove Device", tint = MaterialTheme.colorScheme.error)
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        confirmButton = {
                            TextButton(onClick = { showDeviceManagementDialog = false }) {
                                Text("Close")
                            }
                        }
                    )
                }

                if (uiState.showCollaboratorActionDialog) {
                    val action = uiState.collaboratorActionType
                    val presence = uiState.selectedPresence
                    if (action != null && presence != null) {
                        val title = if (action == songwritersnotebook.app.viewmodels.CollaboratorAction.REMOVE) "Remove Collaborator?" else "Block User?"
                        val message = if (action == songwritersnotebook.app.viewmodels.CollaboratorAction.REMOVE) {
                            "Are you sure you want to remove ${presence.username} (${presence.email}) from this song?"
                        } else {
                            "Are you sure you want to remove ${presence.username} and block them? They will no longer be able to collaborate on any of your songs."
                        }

                        AlertDialog(
                            onDismissRequest = { viewModel.dismissCollaboratorAction() },
                            title = { Text(title) },
                            text = { Text(message) },
                            confirmButton = {
                                Button(
                                    onClick = { viewModel.confirmCollaboratorAction() },
                                    colors = ButtonDefaults.buttonColors(containerColor = MaterialTheme.colorScheme.error)
                                ) {
                                    Text(if (action == songwritersnotebook.app.viewmodels.CollaboratorAction.REMOVE) "Remove" else "Block")
                                }
                            },
                            dismissButton = {
                                TextButton(onClick = { viewModel.dismissCollaboratorAction() }) {
                                    Text("Cancel")
                                }
                            }
                        )
                    }
                }

                Column(
                    modifier = Modifier
                        .padding(paddingValues)
                        .consumeWindowInsets(paddingValues)
                        .fillMaxSize()
                ) {
                    val isWeb = remember { songwritersnotebook.app.getPlatform().name.contains("Web", ignoreCase = true) }
                    if (isWeb && !isPreviewMode && subscriptionTier != SubscriptionTier.STUDIO) {
                        Surface(
                            modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp, vertical = 8.dp),
                            color = MaterialTheme.colorScheme.tertiaryContainer,
                            shape = RoundedCornerShape(8.dp),
                            tonalElevation = 2.dp
                        ) {
                            Row(
                                modifier = Modifier.padding(12.dp),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Icon(Icons.Default.Info, contentDescription = null, tint = MaterialTheme.colorScheme.onTertiaryContainer)
                                Spacer(Modifier.width(12.dp))
                                Column(modifier = Modifier.weight(1f)) {
                                    Text(
                                        "Studio Subscription Required",
                                        style = MaterialTheme.typography.labelLarge,
                                        color = MaterialTheme.colorScheme.onTertiaryContainer,
                                        fontWeight = FontWeight.Bold
                                    )
                                    Text(
                                        "Saving and syncing on the web is exclusive to Studio subscribers. Upgrade to keep your changes!",
                                        style = MaterialTheme.typography.bodySmall,
                                        color = MaterialTheme.colorScheme.onTertiaryContainer
                                    )
                                }
                                TextButton(onClick = onNavigateToSubscription) {
                                    Text("Upgrade")
                                }
                            }
                        }
                    }

                    if (uiState.audioSyncProgress != null) {
                        // REMOVED: LinearProgressIndicator(modifier = Modifier.fillMaxWidth())
                    }

                    val activeSong = uiState.versionPreview ?: uiState.song

                    if (uiState.isLoading || activeSong == null) {
                         Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                             CircularProgressIndicator()
                         }
                    } else {
                        val lazyListState = rememberLazyListState()
                        val density = LocalDensity.current
                        
                        LaunchedEffect(uiState.nextFocusRequest) {
                            val request = uiState.nextFocusRequest
                            val song = uiState.song ?: uiState.versionPreview
                            if (request != null && song != null) {
                                var index = 0
                                // 0: InstrumentInfoHeader
                                index++
                                
                                // 1: SongNotesCard (if active)
                                if (song.showNotes && song.notes.isNotBlank()) {
                                    index++
                                }
                                
                                var found = false
                                for (section in song.sections) {
                                    if (uiState.editorSettings.showSectionHeaders) {
                                        if (request.targetId == section.id && request.isSectionTitle) {
                                            found = true
                                            break
                                        }
                                        index++ // Section Title
                                        
                                        if (uiState.editorSettings.showTabs && section.tabs.isNotEmpty()) {
                                            index++
                                        }
                                    }
                                    
                                    for (line in section.lines) {
                                        if (request.targetId == line.id && !request.isSectionTitle) {
                                            found = true
                                            break
                                        }
                                        index++ // Lyric Line
                                        
                                        if (uiState.editorSettings.showTabs && line.tabs.isNotEmpty()) {
                                            index++
                                        }
                                    }
                                    if (found) break
                                }
                                
                                if (found) {
                                    // Use an offset to keep the line roughly 1/3 down the screen
                                    // This prevents it from being stuck at the absolute top or bottom (under keyboard)
                                    val offset = with(density) { 150.dp.roundToPx() }
                                    lazyListState.animateScrollToItem(index, -offset)
                                }
                            }
                        }

                        // Provide a static generous bottom padding so the last line can ALWAYS
                        // be scrolled well above the keyboard when typing.
                        val bottomPadding = 300.dp

                        LazyColumn(
                            state = lazyListState,
                            modifier = Modifier
                                .weight(1f)
                                .fillMaxWidth()
                                .imePadding(),
                            contentPadding = PaddingValues(
                                top = 8.dp,
                                bottom = bottomPadding
                            )
                        ) {
                            item {
                                InstrumentInfoHeader(
                                    song = activeSong,
                                    settings = uiState.editorSettings,
                                    chordsInUse = uiState.chordsInUse
                                )
                            }

                            if (activeSong.showNotes && activeSong.notes.isNotBlank()) {
                                item {
                                    SongNotesCard(notes = activeSong.notes)
                                    Spacer(Modifier.height(16.dp))
                                }
                            }

                            activeSong.sections.forEachIndexed { sectionIndex, section ->
                                val currentNextFocusRequest = uiState.nextFocusRequest

                                // PRO UI: Add extra room at the top of the first section 
                                // so the 'Add Media' button doesn't overlap with floating Undo/Redo buttons.
                                if (sectionIndex == 0) {
                                    item { Spacer(Modifier.height(24.dp)) }
                                }

                                if (uiState.editorSettings.showSectionHeaders) {
                                    item(key = "section_${section.id}") {
                                        if (sectionIndex > 0) {
                                            Spacer(Modifier.height(24.dp))
                                        }
                                        EditableSectionTitle(
                                            section = section,
                                            onTitleChange = { newTitle ->
                                                viewModel.updateSectionTitle(sectionIndex, newTitle)
                                            },
                                            onSelect = { if (!isPreviewMode) viewModel.selectItem(sectionIndex, null) },
                                            focusRequest = if (currentNextFocusRequest?.targetId == section.id && currentNextFocusRequest.isSectionTitle) currentNextFocusRequest else null,
                                            onFocusHandled = { viewModel.onFocusHandled() },
                                            onFocus = { isFocused -> if (!isPreviewMode) viewModel.onSectionTitleFocusChanged(sectionIndex, isFocused) },
                                            hasMedia = !activeSong.recordings[section.id].isNullOrEmpty() || section.tabs.isNotEmpty(),
                                            onManageRecordings = { viewModel.openLineMediaSheet(section.id) },
                                            onDeleteHeaderRequest = { viewModel.deleteSectionHeaderOrMerge(sectionIndex) },
                                            readOnly = isPreviewMode || uiState.isViewer,
                                            remotePresences = uiState.presence.values.filter { it.activeSectionId == section.id && it.activeLineId == null },
                                            onNavigateUp = { horizontalOffset ->
                                                viewModel.navigateFocusUp(sectionIndex, null, horizontalOffset)
                                            },
                                            onNavigateDown = { horizontalOffset ->
                                                viewModel.navigateFocusDown(sectionIndex, null, horizontalOffset)
                                            }
                                        )
                                    }

                                    if (uiState.editorSettings.showTabs && section.tabs.isNotEmpty()) {
                                        item(key = "section_tabs_${section.id}") {
                                            LazyRow(
                                                contentPadding = PaddingValues(horizontal = 16.dp, vertical = 4.dp),
                                                horizontalArrangement = Arrangement.spacedBy(16.dp)
                                            ) {
                                                items(section.tabs) { tab ->
                                                    val tabRecordings = activeSong.recordings.values.flatten().filter { it.id in tab.recordingIds }
                                                    Box(modifier = Modifier.clickable {
                                                        if (isPreviewMode) {
                                                            if (tabRecordings.isNotEmpty()) viewModel.playRecording(tabRecordings.last())
                                                        } else if (canUseTabs) {
                                                            viewModel.openTabEditor(section.id, tab)
                                                        }
                                                    }) {
                                                        TabDisplay(
                                                            tab = tab,
                                                            isPlaying = tabRecordings.any { it.id == uiState.playingRecordingId },
                                                            onPlay = if (tabRecordings.isNotEmpty()) {
                                                                { viewModel.playRecording(tabRecordings.last()) }
                                                            } else null,
                                                            remotePresences = uiState.presence.values.filter { it.activeTabId == tab.id }
                                                        )
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }

                                section.lines.forEachIndexed { lineIndex, line ->
                                    item(key = line.id) {
                                        val contextMenuModifier = if (!isPreviewMode && sectionIndex == 0 && lineIndex == 0) {
                                            Modifier.tutorialTarget(TutorialStep.EDITOR_CONTEXT_MENU_OPEN)
                                        } else {
                                            Modifier
                                        }

                                        EditableLyricLine(
                                            line = line,
                                            onTextChange = { newTextFieldValue ->
                                                viewModel.updateLineText(sectionIndex, lineIndex, newTextFieldValue)
                                            },
                                            editorSettings = uiState.editorSettings,
                                            onSelect = { 
                                                if (!isPreviewMode) {
                                                    if (sectionIndex == 0 && lineIndex == 0 && (TutorialManager.currentStep.value) == TutorialStep.EDITOR_CONTEXT_MENU_OPEN) {
                                                        TutorialManager.nextStep()
                                                    }
                                                    viewModel.selectItem(sectionIndex, lineIndex) 
                                                }
                                            },
                                            onChordInsert = { cursorPosition ->
                                                uiState.selectedChordToPlace?.let { chord ->
                                                    viewModel.insertChordAtCursor(sectionIndex, lineIndex, cursorPosition, chord)
                                                }
                                            },
                                            isChordArmed = !isPreviewMode && uiState.selectedChordToPlace != null,
                                            rhymeData = uiState.rhymeData,
                                            focusRequest = if (currentNextFocusRequest?.targetId == line.id && !currentNextFocusRequest.isSectionTitle) currentNextFocusRequest else null,
                                            onFocusHandled = { viewModel.onFocusHandled() },
                                            onFocus = { isFocused -> if (!isPreviewMode) viewModel.onLineFocusChanged(sectionIndex, lineIndex, isFocused) },
                                            onMergeRequest = {
                                                viewModel.mergeLineWithPrevious(sectionIndex, lineIndex, line.text)
                                            },
                                            contextMenuModifier = contextMenuModifier,
                                            hasMedia = !activeSong.recordings[line.id].isNullOrEmpty() || line.tabs.isNotEmpty(),
                                            onManageRecordings = { viewModel.openLineMediaSheet(line.id) },
                                            fontSize = fontSize,
                                            canUseTabs = canUseTabs,
                                            readOnly = isPreviewMode || uiState.isViewer,
                                            remotePresences = uiState.presence.values.filter { it.activeLineId == line.id },
                                            onNavigateUp = { horizontalOffset ->
                                                viewModel.navigateFocusUp(sectionIndex, lineIndex, horizontalOffset)
                                            },
                                            onNavigateDown = { horizontalOffset ->
                                                viewModel.navigateFocusDown(sectionIndex, lineIndex, horizontalOffset)
                                            }
                                        )
                                    }

                                    if (uiState.editorSettings.showTabs && line.tabs.isNotEmpty()) {
                                        item(key = "line_tabs_${line.id}") {
                                            LazyRow(
                                                contentPadding = PaddingValues(start = 40.dp, end = 16.dp, top = 4.dp, bottom = 12.dp),
                                                horizontalArrangement = Arrangement.spacedBy(16.dp)
                                            ) {
                                                items(line.tabs) { tab ->
                                                    val tabRecordings = activeSong.recordings.values.flatten().filter { it.id in tab.recordingIds }
                                                    Box(modifier = Modifier.clickable {
                                                        if (isPreviewMode) {
                                                            if (tabRecordings.isNotEmpty()) viewModel.playRecording(tabRecordings.last())
                                                        } else if (canUseTabs) {
                                                            viewModel.openTabEditor(line.id, tab)
                                                        }
                                                    }) {
                                                        TabDisplay(
                                                            tab = tab,
                                                            isPlaying = tabRecordings.any { it.id == uiState.playingRecordingId },
                                                            onPlay = if (tabRecordings.isNotEmpty()) {
                                                                { viewModel.playRecording(tabRecordings.last()) }
                                                            } else null,
                                                            remotePresences = uiState.presence.values.filter { it.activeTabId == tab.id }
                                                        )
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                // Undo/Redo Buttons & Presence Overlay
                if (!uiState.isViewer && !isPreviewMode) {
                    val sessionDeviceId = viewModel.sessionDeviceId
                    val allPresences = uiState.presence.values.filter { it.deviceId != sessionDeviceId }
                    


                    val displayPresences = allPresences

                    Box(
                        modifier = Modifier
                            .align(Alignment.TopEnd)
                            .padding(paddingValues)
                            .padding(top = 2.dp, end = 12.dp)
                            .zIndex(10f),
                        contentAlignment = Alignment.CenterEnd
                    ) {
                        // Background Presence Row
                        if (displayPresences.isNotEmpty()) {
                            Row(
                                modifier = Modifier
                                    .padding(end = 80.dp)
                                    .widthIn(max = 140.dp)
                                    .horizontalScroll(rememberScrollState()),
                                horizontalArrangement = Arrangement.spacedBy((-8).dp),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                displayPresences.forEach { presence ->
                                    Box(
                                        modifier = Modifier
                                            .size(28.dp)
                                            .zIndex(10f)
                                            .border(1.5.dp, MaterialTheme.colorScheme.background, CircleShape)
                                            .clip(CircleShape)
                                            .background(Color(if (presence.color != 0) presence.color else songwritersnotebook.app.data.UserPresence.generateUserColor(presence.userId)))
                                            .clickable(!uiState.isShared) { viewModel.onPresenceClicked(presence) },
                                        contentAlignment = Alignment.Center
                                    ) {
                                        val identifier = if (presence.email.isNotEmpty()) presence.email else if (presence.username.isNotEmpty()) presence.username else "A"
                                        val initial = identifier.trim().take(1).uppercase()
                                        val isWeb = songwritersnotebook.app.getPlatform().name.contains("Web", ignoreCase = true)
                                        val textModifier = if (isWeb) Modifier.offset(y = (-1).dp) else Modifier
                                        Text(
                                            text = initial,
                                            fontSize = 12.sp,
                                            color = Color.White,
                                            fontWeight = FontWeight.Bold,
                                            modifier = textModifier
                                        )
                                    }
                                }
                            }
                        }

                        // Collaborator Management Card
                        uiState.selectedPresence?.let { presence ->
                            androidx.compose.ui.window.Popup(
                                alignment = Alignment.TopEnd,
                                offset = IntOffset(0, 40),
                                onDismissRequest = { viewModel.onDismissPresenceCard() }
                            ) {
                                Card(
                                    modifier = Modifier
                                        .padding(end = 12.dp)
                                        .width(240.dp),
                                    elevation = CardDefaults.cardElevation(8.dp),
                                    colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface)
                                ) {
                                    val isSelf = presence.userId == currentUserId
                                    val isEditor = uiState.song?.collaborators?.contains(presence.userId) == true
                                    
                                    Column(modifier = Modifier.padding(16.dp)) {
                                        Row(verticalAlignment = Alignment.CenterVertically) {
                                            Text(
                                                text = if (isSelf) "My Session" else presence.username.ifBlank { "Unknown User" },
                                                style = MaterialTheme.typography.titleMedium,
                                                fontWeight = FontWeight.Bold,
                                                modifier = Modifier.weight(1f)
                                            )
                                            if (!isSelf) {
                                                Icon(
                                                    imageVector = if (isEditor) Icons.Default.Edit else Icons.Default.Visibility,
                                                    contentDescription = if (isEditor) "Editor" else "Viewer",
                                                    tint = MaterialTheme.colorScheme.primary,
                                                    modifier = Modifier.size(16.dp)
                                                )
                                            }
                                        }
                                        Text(
                                            text = if (isSelf) "Manage your active devices" else presence.email.ifBlank { "No email provided" },
                                            style = MaterialTheme.typography.bodySmall,
                                            color = MaterialTheme.colorScheme.onSurfaceVariant
                                        )
                                        
                                        Spacer(Modifier.height(16.dp))
                                        
                                        if (isSelf) {
                                            Button(
                                                onClick = { 
                                                    showDeviceManagementDialog = true
                                                    viewModel.onDismissPresenceCard()
                                                },
                                                modifier = Modifier.fillMaxWidth()
                                            ) {
                                                Icon(Icons.Default.Devices, contentDescription = null, modifier = Modifier.size(18.dp))
                                                Spacer(Modifier.width(8.dp))
                                                Text("Manage Devices")
                                            }
                                        } else {
                                            OutlinedButton(
                                                onClick = { viewModel.onToggleRoleClicked() },
                                                modifier = Modifier.fillMaxWidth(),
                                                contentPadding = PaddingValues(horizontal = 8.dp)
                                            ) {
                                                Icon(
                                                    imageVector = if (isEditor) Icons.Default.Visibility else Icons.Default.Edit,
                                                    contentDescription = null,
                                                    modifier = Modifier.size(16.dp)
                                                )
                                                Spacer(Modifier.width(8.dp))
                                                Text(if (isEditor) "Make Viewer" else "Make Editor", fontSize = 12.sp)
                                            }
                                            
                                            Spacer(Modifier.height(8.dp))
                                            
                                            Row(
                                                modifier = Modifier.fillMaxWidth(),
                                                horizontalArrangement = Arrangement.spacedBy(8.dp)
                                            ) {
                                                Button(
                                                    onClick = { viewModel.onCollaboratorAction(songwritersnotebook.app.viewmodels.CollaboratorAction.REMOVE) },
                                                    colors = ButtonDefaults.buttonColors(containerColor = MaterialTheme.colorScheme.errorContainer, contentColor = MaterialTheme.colorScheme.onErrorContainer),
                                                    modifier = Modifier.weight(1f),
                                                    contentPadding = PaddingValues(horizontal = 8.dp)
                                                ) {
                                                    Text("Remove", fontSize = 12.sp)
                                                }
                                                Button(
                                                    onClick = { viewModel.onCollaboratorAction(songwritersnotebook.app.viewmodels.CollaboratorAction.BLOCK) },
                                                    colors = ButtonDefaults.buttonColors(containerColor = MaterialTheme.colorScheme.error, contentColor = MaterialTheme.colorScheme.onError),
                                                    modifier = Modifier.weight(1f),
                                                    contentPadding = PaddingValues(horizontal = 8.dp)
                                                ) {
                                                    Text("Block", fontSize = 12.sp)
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        // Foreground Undo/Redo Surface
                        Surface(
                            color = MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.7f),
                            shape = RoundedCornerShape(6.dp),
                            tonalElevation = 1.dp
                        ) {
                            Row(
                                modifier = Modifier.padding(horizontal = 4.dp, vertical = 2.dp),
                                horizontalArrangement = Arrangement.spacedBy(4.dp),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                IconButton(
                                    onClick = { viewModel.undo() },
                                    enabled = uiState.canUndo,
                                    modifier = Modifier.size(32.dp)
                                ) {
                                    Icon(
                                        Icons.AutoMirrored.Filled.Undo, 
                                        contentDescription = "Undo", 
                                        modifier = Modifier.size(18.dp),
                                        tint = if (uiState.canUndo) MaterialTheme.colorScheme.onSurfaceVariant else MaterialTheme.colorScheme.onSurfaceVariant.copy(alpha = 0.5f)
                                    )
                                }

                                IconButton(
                                    onClick = { viewModel.redo() },
                                    enabled = uiState.canRedo,
                                    modifier = Modifier.size(32.dp)
                                ) {
                                    Icon(
                                        Icons.AutoMirrored.Filled.Redo, 
                                        contentDescription = "Redo", 
                                        modifier = Modifier.size(18.dp),
                                        tint = if (uiState.canRedo) MaterialTheme.colorScheme.onSurfaceVariant else MaterialTheme.colorScheme.onSurfaceVariant.copy(alpha = 0.5f)
                                    )
                                }
                            }
                        }
                    }
                }
            }
        }

        WordFinderPopup(
            showPopup = uiState.showWordFinderPopup,
            searchTerm = uiState.wordFinderSearchTerm,
            selectedTab = uiState.wordFinderSelectedTab,
            rhymeResults = uiState.rhymeResults,
            synonymResults = uiState.synonymResults,
            isLoading = uiState.isWordFinderLoading,
            error = uiState.wordFinderError,
            onDismiss = { viewModel.closeWordFinderPopup() },
            onSearchTermChange = { term -> viewModel.updateWordFinderSearchTerm(term) },
            onTabSelected = { tab -> viewModel.selectWordFinderTab(tab) },
            onSearchClick = { viewModel.findWords() }
        )

        if (uiState.isExporting) {
            LoadingOverlay(message = "Exporting Audio...")
        }

        // New AI Assistant Panel (Fresh Start)
        songwritersnotebook.app.components.AiAssistantPanel(
            isVisible = uiState.showAiAssistantSheet,
            onDismiss = { viewModel.onAiAssistantDismiss() },
            viewModel = viewModel,
            userProfile = userProfile,
            bottomPadding = WindowInsets.navigationBars.asPaddingValues() // Correct padding outside Scaffold
        )

        HarmonyAssistantOverlay(
            uiState = uiState,
            onApprove = { viewModel.onHarmonyActionApprove(it) },
            onReject = { viewModel.onHarmonyActionReject(it) },
            onApproveAll = { viewModel.onHarmonyActionApproveAll() },
            onDismiss = { viewModel.dismissHarmonyOverlay() },
            onSwipeUp = { 
                viewModel.openAiAssistant()
                viewModel.selectAiAssistantTab(2) // 2 is Harmony Chat
            }
        )
    }
}

